import React from 'react';
import { Box, Text, HStack, Badge } from '@chakra-ui/react';
import { TimeIcon } from '@chakra-ui/icons';

const EventCard = ({ event, onClick, isCompact = false }) => {
  const getEventColor = () => {
    switch (event.type) {
      case 'appointment':
        return 'blue';
      case 'meeting':
        return 'purple';
      case 'task':
        return 'green';
      case 'reminder':
        return 'orange';
      default:
        return 'gray';
    }
  };

  const getEventTypeLabel = () => {
    switch (event.type) {
      case 'appointment':
        return 'Compromisso';
      case 'meeting':
        return 'Reunião';
      case 'task':
        return 'Tarefa';
      case 'reminder':
        return 'Lembrete';
      default:
        return 'Outro';
    }
  };

  const formatTime = (date) => {
    return new Date(date).toLocaleTimeString('pt-BR', {
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const colorScheme = getEventColor();

  if (isCompact) {
    return (
      <Box
        p={1}
        mb={1}
        bg={`${colorScheme}.500`}
        color="white"
        borderRadius="md"
        fontSize="xs"
        cursor="pointer"
        onClick={onClick}
        _hover={{ bg: `${colorScheme}.600` }}
        overflow="hidden"
        textOverflow="ellipsis"
        whiteSpace="nowrap"
      >
        <Text>
          {!event.allDay && formatTime(event.startDate)} - {event.title}
        </Text>
      </Box>
    );
  }

  return (
    <Box
      p={3}
      mb={2}
      bg={event.status === 'cancelled' ? 'gray.100' : `${colorScheme}.50`}
      borderLeftWidth="4px"
      borderLeftColor={`${colorScheme}.500`}
      borderRadius="md"
      cursor="pointer"
      onClick={onClick}
      _hover={{ 
        transform: 'translateY(-2px)', 
        shadow: 'md',
        transition: 'all 0.2s'
      }}
      opacity={event.status === 'cancelled' ? 0.6 : 1}
    >
      <HStack justify="space-between" mb={1}>
        <Text 
          fontWeight="bold" 
          color={`${colorScheme}.700`}
          textDecoration={event.status === 'cancelled' ? 'line-through' : 'none'}
        >
          {event.title}
        </Text>
        <Badge colorScheme={colorScheme} fontSize="xs">
          {getEventTypeLabel()}
        </Badge>
      </HStack>
      
      {!event.allDay && (
        <HStack spacing={1} fontSize="sm" color="gray.600">
          <TimeIcon />
          <Text>
            {formatTime(event.startDate)} - {formatTime(event.endDate)}
          </Text>
        </HStack>
      )}
      
      {event.location && (
        <Text fontSize="sm" color="gray.600" mt={1}>
          📍 {event.location}
        </Text>
      )}
      
      {event.participants && event.participants.length > 0 && (
        <HStack mt={2} spacing={1}>
          <Text fontSize="xs" color="gray.500">
            Participantes:
          </Text>
          {event.participants.slice(0, 2).map((participant, index) => (
            <Badge key={index} size="sm" variant="subtle" colorScheme={colorScheme}>
              {participant.nomeCompleto?.split(' ')[0] || participant.username}
            </Badge>
          ))}
          {event.participants.length > 2 && (
            <Text fontSize="xs" color="gray.500">
              +{event.participants.length - 2}
            </Text>
          )}
        </HStack>
      )}
    </Box>
  );
};

export default EventCard;